<template>
  <teleport to="body">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 bg-slate-950/70 backdrop-blur-md flex items-center justify-center p-4 animate-fade-in"
      @click.self="handleCancel"
    >
      <div
        class="bg-white dark:bg-[#111C30] rounded-2xl sm:rounded-3xl shadow-2xl border border-slate-200/90 dark:border-[#263449] max-w-sm sm:max-w-md w-full overflow-hidden flex flex-col transform transition-all duration-200"
      >
        <!-- Header -->
        <div class="px-6 py-5 border-b border-slate-100 dark:border-[#263449]">
          <h2 class="text-base sm:text-lg font-bold text-slate-900 dark:text-white tracking-tight">
            {{ title }}
          </h2>
        </div>

        <!-- Body -->
        <div class="px-6 py-5 bg-slate-50/50 dark:bg-[#0B1120]/40">
          <p class="text-xs sm:text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
            {{ message }}
          </p>
        </div>

        <!-- Footer -->
        <div
          class="px-6 py-4 bg-white dark:bg-[#111C30] border-t border-slate-100 dark:border-[#263449] flex items-center justify-end gap-2.5"
        >
          <button
            @click="handleCancel"
            :disabled="isLoading"
            class="px-4 py-2 rounded-xl text-xs sm:text-sm font-semibold text-slate-700 dark:text-slate-300 bg-slate-100 dark:bg-[#18243A] hover:bg-slate-200 dark:hover:bg-[#1F2E49] border border-slate-200/70 dark:border-[#263449] disabled:opacity-50 transition-colors"
          >
            Cancel
          </button>
          <button
            @click="handleConfirm"
            :disabled="isLoading"
            class="px-4 py-2 rounded-xl text-xs sm:text-sm font-semibold text-white bg-rose-600 hover:bg-rose-700 shadow-sm shadow-rose-600/20 disabled:opacity-50 transition-colors inline-flex items-center gap-2"
          >
            <AppLoader
              v-if="isLoading"
              variant="button"
              class="w-3.5 h-3.5 text-white"
            />
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
  import { defineProps, defineEmits } from "vue";

  defineProps({
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Confirm Action",
    },
    message: {
      type: String,
      default: "Are you sure?",
    },
    confirmText: {
      type: String,
      default: "Delete",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["confirm", "cancel"]);

  const handleConfirm = () => {
    emit("confirm");
  };

  const handleCancel = () => {
    emit("cancel");
  };
</script>

<style scoped>
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .animate-in {
    animation: slideIn 0.2s ease-out;
  }
</style>
